import { useAppContextNonNull } from "@contexts/AppContext";
import QuickbooksConnect from "./QuickbooksConnect";
import UIService from "@services/UIService";
import ICatalog from "@models/ICatalog";

type Props = {
    catalogs: ICatalog[];
};

export const QuickbooksConnectWrapper = ({ catalogs }: Props) => {
    const { userModel, supplierModel, uiContext, socket } = useAppContextNonNull();

    return (
        <div>
            <QuickbooksConnect
                userModel={userModel}
                supplierModel={supplierModel}
                setActivityIndicator={uiContext.setActivityIndicator}
                socket={socket}
                notifyFn={uiContext.notifyFn}
                isMainViewLight={UIService.isMainViewLight()}
                catalogs={catalogs}
                showHiddenFeatures={uiContext.showHiddenFeatures}
            />
        </div>
    );
};
